import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import memoize from 'memoizerific'
import { chain, findIndex, compact, keys, isUndefined, isEmpty, groupBy } from 'lodash'

import {
  ButtonToolbar, ButtonGroup, Modal, Table, Panel, Glyphicon
} from "react-bootstrap"

import { maxBy, printMoney } from 'Lib/Tools'
import { getTripBill, calculateTripPriceFromBill } from 'Lib/TripTools'
import getRouteWarnings from 'Lib/routeWarnings'
import { isMobile } from '../lib/AppTools'

import Item from '../routes/AgendaItem'
import NextCitySelector from '../routes/NextCitySelector'
import ContentSelector from '../routes/ContentSelector'
import BlockSelector from '../routes/BlockSelector'
import ExpenseSelector from '../routes/ExpenseSelector'
import SortableList from '../components/SortableList'

import Button from '../components/Button'
import MyMapComponent from '../components/GoogleMap'
import { getText, nameOrTitle, translateCity } from '../lib/text'
import ExpensesList from '../components/ExpensesList'
import { emptyTrip } from '../ducks/trips'
import * as uiActions from '../actions/ui'

import config from "../../../config.app"

import "./Agenda.less"
import { getSelection, getUniqExpenses, getPriceValuePerItem, getGoogleRoute, getTimeRoute } from './Agenda.aux'

/**
 * Agenda
 */

type Props = {
  route: Object,
  startDate: string,

  Activities: { [string]: Object },
  Routes: { [string]: Object },

  blockTemplatesList: [Object],

  AliveActivitiesList: [Object],
  ExpensesList: [Object],
  CitiesList: [string],
  Cities: Object,

  addBlock: (Object, string) => void,
  addCity: (Object, string) => void,
  addActivity: (Object, string) => void,
  addExpense: (Object, string) => void,
  addDay: () => void,
  remove: (string) => void,
  move: (string, string) => void,
  multiMove: ([string], string) => void,
  repeatExpense: () => void,
  replaceWithBlock: Function,
  moveItem: Function,

  cloneRouteToTemplate: Function,
  cloneSelectionToTemplate: Function,

  top: ?number,
  language: string,

  isTemplate: boolean
}

const _getDate = (startDate, daysCounter) => moment(startDate).add(daysCounter - 1, "days")
const getDate = memoize(1000)(_getDate)

const _getRouteListData = (agenda) => compact(agenda)
const getRouteListData = memoize(10)(_getRouteListData)

const _buildAgenda = (route) => route.agenda.filter(x => !(x.type == "activity" && !x.id))
const buildAgenda = memoize(10)(_buildAgenda)

class Agenda extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      addTab: null,
      mode: "order",
      addingType: "activity", // "activity"|"city"|"block"|"note"
      adding: null,
      showModal: null,
      forceCompact: false,
      previousCompact: false,
      selected: {},
      animation: true,
      temporalSort: null,    // while items are being dragged, this contains the new order; nulled again when dropped
      filterCity: "Madrid",  // filter the content selectors by this city
      filterSelectors: true, // filter in blockSelector and expenseSelector
      dayHovered: 0,
      lastDayHovered: 0,
      scrollStatus: false,
      routeTimes: [],
      editingKey: null,
    }
    this._timeout = null;
    this.handleScroll = this.handleScroll.bind(this);
    this.onStartEdit = this.onStartEdit.bind(this);
    this.onEndEdit = this.onEndEdit.bind(this);
    this.select = this.select.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
  }

  static getDerivedStateFromProps(props, state) {

  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showModal != this.state.showModal) {
      this.props.toggleModal("Agenda:showModal", this.state.showModal)
    }
    const { route, Cities, Activities } = this.props
    if ((route != prevProps.route || isEmpty(prevState.routeTimes)) && Cities && Activities) {
      const agenda = buildAgenda(route)
      const routeListData = getRouteListData(agenda)
      const googleRoute = getGoogleRoute(routeListData, Cities, Activities)
      const routeTimes = getTimeRoute(googleRoute)
      routeTimes.then(rt => {
        if (rt.length > 0) {
          const newRouteTimes = chain(rt).flatten().compact().groupBy('placei').value()
          if (!isEmpty(newRouteTimes)) this.setState({ routeTimes: chain(rt).flatten().compact().groupBy('placei').value() })
        }
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.route._id != nextProps.route._id) {
      this.setState({ showModal: null })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.state.showModal) {
      this.props.toggleModal("Agenda:showModal", false)
    }
  }

  // get all items in the selected days
  getSelection() {
    return getSelection(
      compact(this.props.route.agenda),
      this.state.selected
    )
  }

  // get the key of all selected days
  getSelectedKeys() {
    return keys(this.state.selected).filter(k => this.state.selected[k])
  }

  startAddNote(cancel = false) {
    if (cancel) this.startAdd("note", null)
    else this.startAdd("note", "Nota")
  }

  startAddCity(city) {
    this.startAdd("city", this.props.Cities[city])
  }

  startAddActivity(activity) {
    this.startAdd("activity", activity)
  }

  startAddExpense(expense) {
    this.startAdd("expense", expense)
  }

  startAddBlock(block) {
    this.startAdd("block", block)
  }

  startAdd(addingType, item) {
    if (!item) this.setState({ mode: "order", adding: null })
    else this.setState({
      mode: "add",
      adding: { item, name: item.name || "" },
      addingType,
      showModal: null,
      addTab: null
    })
  }

  add(i) {
    if (this.state.addingType == "day") this.props.addDay(i + 1)
    else if (this.state.addingType == "note") this.props.addNote(i + 1)
    else if (this.state.addingType == "activity") {
      this.props.addActivity(this.state.adding.item, i + 1)
    }
    else if (this.state.addingType == "city") { // #TODO why?
      //this.props.addCity(this.state.adding.name, i + 1) #TODO why name??
      this.props.addCity(this.state.adding.item._id, i + 1)
    }
    else if (this.state.addingType == "block") {
      this.props.addBlock(this.state.adding.item, i + 1)
    }
    else if (
      this.state.addingType == "expense"
      || this.state.addingType == "hotel"
    ) {
      this.props.addExpense(this.state.adding.item, i + 1)
    }

    this.setState({ compact: this.state.previousCompact, mode: "order", adding: null })
  }

  addLast(type, x) {
    const last = this.props.route.agenda.length

    if (type === "activity") this.props.addActivity(x, last)
    else if (type === "city") this.props.addCity(x, last)
    else if (type === "block") this.props.addBlock(x, last)

    this.setState({ mode: "order", adding: null })
  }

  getTitle(item) {
    if (this.state.addingType == "city") return translateCity(item)
    else if (this.state.addingType == "note") return getText("Nota")
    else return nameOrTitle(item)
  }

  handleScroll(eventIgnored) {
    if (this._timeout) { // if there is already a timeout in process cancel it
      clearTimeout(this._timeout)
    }
    this._timeout = setTimeout(() => {
      this._timeout = null
      this.setState({
        scrollStatus: false,
        dayHovered: this.state.lastDayHovered,
      })
    }, 300)
    if (this.state.scrollStatus !== 'scrolling') {
      this.setState({
        scrollStatus: true
      })
    }
  }

  toggleMulti(vv) {
    const v = isUndefined(vv) ? this.state.mode != "multi" : vv
    this.setState({
      mode: v ? "multi" : "order",
      selected: {}
    })
  }

  compactView() {
    return this.state.forceCompact || this.state.mode == "multi" || this.state.mode == "add"
  }

  anySelected() {
    return Object.keys(this.state.selected).some(k => this.state.selected[k])
  }


  props: Props

  importSelection() {
    const n = prompt(getText("Introduce el nombre de la nueva plantilla"))
    if (n && confirm(getText("Al guardar una selección no se incluyen los gastos generales"))) {
      this.props.cloneSelectionToTemplate(n, this.getSelection())
      this.toggleMulti(false)
    }
  }

  importAll() {
    const n = prompt(getText("Introduce el nombre de la nueva plantilla"))
    if (n) {
      this.props.cloneRouteToTemplate(n, this.props.route._id)
      this.toggleMulti(false)
    }
  }

  canAfterThis(i, addingType) {
    const route = this.props.route
    const length = this.props.route.length
    const next = i < (length - 1) ? route[i + 1] : null

    if (addingType == "hotel") {
      return !next || next.type == "day"
    }
    else {
      // all other types have no requirements yet
      return true
    }
  }

  onSortDrop() {
    const ts = this.state.temporalSort

    if (ts) {
      // find which item has moved the most and where to
      const traveller = maxBy(ts, (x, i) => Math.abs(x.idx - i))
      const newPos = findIndex(ts, x => x.key == traveller.key)

      // TODO emit action for this change
      this.props.moveItem(traveller.idx, newPos)

      this.setState({ temporalSort: null })
    }
  }

  onStartEdit(editingKey) {
    this.setState({ editingKey })
  }

  onEndEdit() {
    this.setState({ editingKey: null })
  }

  select(item, v) {
    this.setState({ selected: Object.assign({}, this.state.selected, { [item.key]: v }) })
  }

  onMouseEnter(item, v) {
    this.setState({ lastDayHovered: v, hoveredItem: this.state.mode == "add" ? item.key : "" })
    if (!this.state.scrollStatus) this.setState({ dayHovered: v })
  }

  render() {
    const { Activities, Cities, CitiesList, route, isTemplate } = this.props
    const bill = this.props.trip
      ? getTripBill(this.props.trip, this.props.route, this.props.Activities, this.props.Cities, { isTemplate })
      : getTripBill(emptyTrip, this.props.route, this.props.Activities, this.props.Cities, { isTemplate })

    const tripPrice = calculateTripPriceFromBill(this.props.trip || emptyTrip, bill)

    const priceValuePerItem = getPriceValuePerItem(bill)

    // ÑAPA
    // there are some activities that... well, idk where they went, but some items just have no id. yea wtf.
    const agenda = buildAgenda(route)

    let daysCounter = 0
    let selected = false

    const warnings = getRouteWarnings(route, this.props.Activities, this.props.startDate)
    /* iter through items, looking for all the expenses that might be ref'd */
    const uniqExpenses = getUniqExpenses(agenda)

    // @WARNING map with side effects. yea i hate myself too.
    const routeListData = getRouteListData(agenda)
    const googleRoute = getGoogleRoute(routeListData, Cities, Activities)
    const routeList = routeListData
      .map((item, i) => {
        if (item.type == "day") {
          selected = this.state.selected[item.key]
          ++daysCounter
        }
        const date = moment(this.props.startDate).add(daysCounter - 1, "days")

        const referencedExpense = item.ref ? uniqExpenses[item.ref] : null

        const itemCity = item.city ? this.props.Cities[item.city] : null
        const itemView = (
          <Item
            key={item.key}
            i={i}
            routeId={this.props.route._id}
            item={item}
            date={getDate(this.props.startDate, daysCounter)}
            routeTimes={JSON.stringify(this.state.routeTimes[i])}
            startDate={this.props.startDate}
            Activities={Activities}
            daysCounter={daysCounter}
            warning={warnings[i] ? JSON.stringify(warnings[i]) : null}

            city={itemCity}
            Cities={this.props.Cities}

            onMouseEnter={this.onMouseEnter}

            isDayHovered={this.state.lastDayHovered == daysCounter}
            referencedExpense={JSON.stringify(referencedExpense)}

            compact={this.compactView()}
            mode={this.state.mode}
            dragging={i == this.state.draggingIndex}
            selected={selected}
            select={this.select}

            editingKey={this.state.editingKey}
            onStartEdit={this.onStartEdit}
            onEndEdit={this.onEndEdit}

            itemInTemplate={this.props.isTemplate}

            priceValue={priceValuePerItem[item.key]}
          />
        )

        if (this.state.mode == "add" && this.canAfterThis(i, this.state.addingType) && this.state.hoveredItem == item.key) {
          // if we're adding and hovering over this, we add a proxy for the new item and the "add here" button
          return [
            itemView,
            <div
              key={this.state.adding.item.key}
              className="fakeItemWrapper"
            >
              <Item
                key={this.state.adding.item.key}
                daysCounter={this.state.addingType == "day" ? daysCounter + 1 : daysCounter}
                i={i}
                routeListData={routeListData}
                item={{
                  ...this.state.adding.item,
                  id: this.state.adding.item._id,
                  type: this.state.addingType,
                  expense: this.state.addingType == "expense" ? this.state.adding.item : {}
                }}
                startDate={this.props.startDate}
                Activities={Activities}
                city={
                  (this.state.addingType == "city"
                    && this.state.adding.item) // This item is expected to be a city object
                  || (this.state.adding.item.city
                    && this.props.Cities[this.state.adding.item.city])
                  || null
                }
                Cities={this.props.Cities}
                onMouseEnter={() => null}
                referencedExpense={this.state.adding.item.ref ? uniqExpenses[this.state.adding.item.ref].expense : null}
                compact={this.compactView()}
                mode={this.state.mode}
                isPlaceHolder
              />
              <Button
                glyph="plus"
                className="addHere"
                onClick={() => this.add(i)}
                label={getText("Añadir aquí")}
              />
            </div>

          ]
        }
        else {
          return itemView
        }
      })

    const toolbar = (
      <ButtonToolbar className="toolbar">
        <Button
          disabled={this.state.mode == "add" || this.state.mode == "multi"}
          onClick={() => this.setState({ forceCompact: !this.state.forceCompact })}
        >
          <Glyphicon glyph={this.state.forceCompact ? "plus" : "minus"} />
          <Glyphicon glyph="info-sign" />
        </Button>
        <Button
          className="save"
          glyph="save"
          onClick={() => (this.anySelected() ? this.importSelection() : this.importAll())}
          label={!this.anySelected()
            ? getText(`Guardar plantilla`)
            : getText(`Guardar selección como plantilla`)
          }
        />

        {
          // buttons to move a day selection
          this.state.mode == "multi" && (
            <ButtonGroup>
              <Button
                glyph="triangle-top"
                disabled={!this.anySelected()}
                onClick={() => this.props.multiMove(this.getSelectedKeys(), "up")}
              />
              <Button
                glyph="triangle-bottom"
                disabled={!this.anySelected()}
                onClick={() => this.props.multiMove(this.getSelectedKeys(), "down")}
              />
            </ButtonGroup>
          )
        }

        <Button
          className="multi"
          glyph={this.state.mode !== "multi" ? "check" : "ok"}
          bsStyle={this.state.mode !== "multi" ? "default" : "success"}
          onClick={() => this.setState({
            selected: {},
            mode: this.state.mode == "multi" ? "order" : "multi",
          })}
          label={this.state.mode != "multi" ? getText("Selección") : getText("OK")}
        />

        {
          this.state.mode != "multi" && (
            <Button
              style={{ borderLeft: "none", float: "right" }}
              disabled={this.state.mode == "multi"}
              glyph="plus"
              onClick={() => this.setState({ showModal: true })}
              bsStyle="primary"
              label={getText("Añadir...")}
            />
          )
        }
      </ButtonToolbar>
    )

    const addingInfo = (
      <div className="addingInfo">
        <strong>
          {getText("Añadiendo ")}
          {/* #WARNING I dont even know what the fuck is going on here */}
          {this.state.adding && this.state.addingType != "day" ? this.state.adding.item ? this.getTitle(this.state.adding.item) : "Sin titulo" : getText("dia_1")}`}
        </strong>
        <Button
          glyph="remove"
          onClick={() => this.setState({ compact: this.state.previousCompact, mode: "order", adding: null, dayHovered: "" })}
          label={getText("Cancelar")}
        />
      </div>
    )
    return (
      <div className="Agenda">
        <div style={{width: !isMobile() ? "56%" : ""}}>
          <div className="toolbarWrapper" style={{ top: this.props.top }}>
            {this.state.mode == "add" ? addingInfo : toolbar}
          </div>
          <div className={`listWrapper ${!isMobile() ? "deskListWrapper" : ""}`}>
            <ExpensesList
              expenses={this.props.route.expenses}
              onChange={expenses => this.props.onChange(expenses)}
              Activities={this.props.Activities}
              mode={this.state.mode}
              priceValues={priceValuePerItem}
            />
            <SortableList
              items={this.state.temporalSort || routeListData.map((x, i) => ({ key: x.key, idx: i }))}
              onUpdate={temporalSort => { this.setState({ temporalSort }) }}
              onDrop={() => this.onSortDrop()}
              setDraggingIndex={(i) => this.setState({ draggingIndex: i })}
              renderItem={x => routeList[x.idx]}
              animate={this.state.animation}
            />
          </div>
        </div>

        <div style={{ marginRight: "1%", marginTop: 5, width: "41%", display: "inline-block", float: "right", top: this.props.top, position: "sticky" }}>
          {
            this.state.showModal && (
              <Modal show onHide={() => this.setState({ showModal: null, addTab: null })}>
                <Modal.Header>
                  <Modal.Title>
                    {
                      (this.state.addTab == "blocks" && getText("Añadir plantilla"))
                      || (this.state.addTab == "activities" && getText("Añadir actividad"))
                      || (this.state.addTab == "cities" && getText("Añadir ciudad"))
                      || (this.state.addTab == "expenses" && getText("Añadir gasto"))
                      || getText("Añadir")
                    }
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {
                    !this.state.addTab && (
                      <ButtonGroup className="add-type-buttons" vertical>
                        <Button
                          glyph="calendar"
                          onClick={() => this.setState({ mode: "add", addingType: "day", adding: { item: {} }, showModal: null })}
                          label={getText("Nuevo día")}
                        />
                        <Button
                          glyph="font"
                          onClick={() => this.startAddNote()}
                          label={getText("Nota")}
                        />
                        {
                          [
                            { key: "blocks", glyph: "th-list", text: "Plantillas" },
                            { key: "cities", glyph: "road", text: "Viaje a ciudad" },
                            { key: "activities", glyph: "camera", text: "Actividades" },
                            { key: "expenses", glyph: "euro", text: "Gastos y hoteles" }
                          ]
                            .map(({ key, glyph, text }) => (
                              <Button
                                key={key}
                                glyph={glyph}
                                onClick={() => this.setState({ addTab: key })}
                                label={getText(text)}
                              />
                            ))
                        }
                      </ButtonGroup>
                    )
                  }

                  <div>
                    <div>
                      {
                        this.state.addTab === "cities" && (
                          <NextCitySelector
                            addCity={(city, last) => {
                              if (last) this.addLast("city", city)
                              else this.startAddCity(city)
                            }}
                            selected={this.state.addingType == "activity" && this.state.adding}
                            filterCity={this.state.filterCity}
                            changeFilterCity={filterCity => this.setState({ filterCity })}
                          />
                        )
                      }
                      {
                        this.state.addTab === "activities" && (
                          <ContentSelector
                            ActivitiesList={this.props.AliveActivitiesList.filter(x => x.city == this.state.filterCity)}
                            addActivity={(a, last) => (last ? this.addLast("activity", a) : this.startAdd("activity", a))}
                            selected={this.state.addingType == "activity" && this.state.adding}
                            filterCity={this.state.filterCity}
                            changeFilterCity={filterCity => this.setState({ filterCity })}
                            language={this.props.language}
                          />
                        )
                      }
                      {
                        this.state.addTab === "expenses" && (
                          <ExpenseSelector
                            CitiesList={CitiesList}
                            add={x => this.startAddExpense(x)}
                            ExpensesList={this.props.ExpensesList}
                            filterCity={this.state.filterCity}
                            selected={this.state.addingType == "expense" && this.state.adding}
                            changeFilterCity={filterCity => this.setState({ filterCity })}
                            filter={this.state.filterSelectors}
                            toggleFilter={filterSelectors => this.setState({ filterSelectors })}
                            language={this.props.language}
                          />
                        )
                      }
                      {
                        // #TODO there is probably a better expression for this (addTab == "block" ?)
                        this.state.addTab == "blocks" && (
                          <BlockSelector
                            Activities={this.props.Activities}
                            BlocksList={this.props.blockTemplatesList}
                            Routes={this.props.Routes}
                            CitiesList={CitiesList}
                            adding={!!this.state.adding}
                            addBlock={(block, last) => (last ? this.addLast("block", block) : this.startAddBlock(block))}
                            replaceWithBlock={block => this.props.replaceWithBlock(block)}
                            selected={this.state.addingType == "block" && this.state.adding}
                            changeFilterCity={filterCity => this.setState({ filterCity })}
                            filterCity={this.state.filterCity}
                            filter={this.state.filterSelectors}
                            toggleFilter={filterSelectors => this.setState({ filterSelectors })}
                            language={this.props.language}
                          />
                        )
                      }
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  {
                    this.state.addTab && (
                      <Button
                        onClick={() => this.setState({ addTab: null })}
                        glyph="arrow-left"
                        label={getText("Atrás")}
                      />
                    )
                  }
                  <Button
                    onClick={() => this.setState({ showModal: null, addTab: null })}
                    bsStyle="primary"
                    label={getText("OK")}
                  />
                </Modal.Footer>
              </Modal>
            )
          }
          {!isMobile() && (
            <React.Fragment>
              <div className="mapWrapper">
                <MyMapComponent
                  Activities={Activities}
                  googleMapError={(googleMapError) => this.setState({ googleMapError })}
                  loadingMap={(loadingMap) => this.setState({ loadingMap })}
                  setLegend={(v) => this.setState({ legend: v })}
                  Cities={this.props.Cities}
                  routeId={this.props.route._id}
                  route={routeListData}
                  googleRoute={googleRoute}
                  day={this.state.dayHovered}
                  googleMapURL={config.google_maps_api}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
                {this.state.loadingMap && <img className="mapLoading" src="../../static/img/Rolling.gif"></img>}
                {this.state.googleMapError && <img className="mapError" src="../../static/img/warning.png"></img>}
              </div>
              <Button
                bsSize="xsmall"
                className="allCitiesButton"
                onClick={() => this.setState({ dayHovered: 0 })}
                label={getText("Ver todas las ciudades")}
              />
              {
                this.state.googleMapError && (
                  <Panel>
                    <Panel.Body>
                      <span><Glyphicon glyph={"warning-sign"} />{this.state.googleMapError}</span>
                    </Panel.Body>
                  </Panel>
                )
              }
              {
                this.state.legend && (
                  <div className="mapLegend">
                    <img src="/static/img/marks/marker_red.png" />
                    <strong>{getText("Actividades con dirección introducida")}</strong>
                    <br />
                    <img src="/static/img/marks/marker_orange.png" />
                    <strong>{getText("Actividades con dirección calculada automáticamente")}</strong>
                  </div>
                )
              }
            </React.Fragment>
          )}

          {
            tripPrice && !isMobile() &&(
              <Table style={{ marginTop: "20px" }} striped bordered condensed hover>
                <tbody>
                  {
                    this.props.useForcedPrice && (
                      <tr className="forcedPrice">
                        <td>{getText("Precio a mano")}</td>
                        <td>{this.props.useForcedPrice ? `${printMoney(tripPrice.finalE)}€ / ${printMoney(tripPrice.finalY)}￥` : `-`}</td>
                      </tr>
                    )
                  }
                  <tr>
                    <td style={{ fontWeight: this.props.useForcedPrice ? "normal" : "bold" }}>
                      {getText("Precio automático")}
                    </td>
                    <td style={{ fontWeight: this.props.useForcedPrice ? "normal" : "bold" }}>
                      {printMoney(tripPrice.calculatedFinalE)}€ / {printMoney(tripPrice.calculatedFinalY)}￥
                    </td>
                  </tr>
                  <tr>
                    <td>{getText("Precio calculado sin %")}</td><td>{printMoney(tripPrice.calculatedBruteE)}€</td>
                  </tr>
                  <tr>
                    <td>{getText("% Gastos de Gestión")}</td>
                    <td>
                      {this.props.pGestion}% ({printMoney(tripPrice.calculatedBruteE * (this.props.pGestion / 100))}€)
                    </td>
                  </tr>
                  {
                    !this.props.trip && (
                      <tr>
                        <td colSpan="2">
                          <i>{getText("(Precio para un adulto (30 años))")}</i>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            )
          }
        </div>
      </div>

    )
  }
}

Agenda.defaultProps = {
  top: 0,
  isTemplate: false,
}

const mapStateToProps = (state) => ({
  Cities: state.cities,
  Activities: state.activities,
  isProduction: state.loginData.isProduction,
})

const mapDispatchToProps = dispatch => ({
  toggleModal: (key, inModal) => dispatch(uiActions.toggleModal(key, inModal))
})

export default connect(mapStateToProps, mapDispatchToProps)(Agenda)
